import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/back_icon.png'
import _imports_1 from '@/assets/img/new/down_active_icon.png'
import _imports_2 from '@/assets/img/new/down_icon.png'
import _imports_3 from '@/assets/img/new/collect_active_icon.png'
import _imports_4 from '@/assets/img/new/collect_icon.png'
import _imports_5 from '@/assets/img/new/thumbs_active_icon.png'
import _imports_6 from '@/assets/img/new/thumbs_icon.png'
import _imports_7 from '@/assets/img/new/comment_icon.png'
import _imports_8 from '@/assets/img/default_headportrait.png'


const _withScopeId = n => (_pushScopeId("data-v-b30f4d88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data_detail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("文件名称")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "操作", -1))
const _hoisted_6 = {
  key: 0,
  class: "data_cont"
}
const _hoisted_7 = { class: "cont_item" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "size" }
const _hoisted_12 = { class: "collect_popup" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_15 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载", -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  src: _imports_3,
  alt: ""
}
const _hoisted_19 = {
  key: 1,
  src: _imports_4,
  alt: ""
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收藏", -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  src: _imports_5,
  alt: ""
}
const _hoisted_23 = {
  key: 1,
  src: _imports_6,
  alt: ""
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点赞", -1))
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "评论", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "comm_box"
}
const _hoisted_30 = { class: "comm_input" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("评论")
const _hoisted_32 = {
  key: 0,
  class: "comm_scorll"
}
const _hoisted_33 = { class: "comm_list" }
const _hoisted_34 = { class: "comm_item" }
const _hoisted_35 = { class: "comment_cont" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_37 = { class: "comment_name" }
const _hoisted_38 = { class: "comment_txt" }
const _hoisted_39 = { class: "commemt_time" }
const _hoisted_40 = {
  key: 1,
  class: "comm_item_btn"
}
const _hoisted_41 = { class: "pagein" }
const _hoisted_42 = { class: "total" }

import { computed, onMounted, reactive, ref, watch } from 'vue';
import { dataInit } from '@/hooks/useDatabaseMenuFiltering'
import getFileTypeImg from '@/hooks/use_type_imgs'
import { useRoute, useRouter } from 'vue-router';
import { getResourcesContent, getSearchResources } from '@/api/database';
import { TMaterialList } from '@/module/database';
import { ElMessage } from 'element-plus'
import { getAddCollect, getRemoveCollect } from '@/api/collect';
import { getAddFabulous, getRemoveFabulous } from '@/api/fabulous';
import { getAddComment, getCommentList } from '@/api/comment';
import { TCommentDataType } from '@/module/comment';
import { fileHandle } from '@/hooks/file_preview_download'
import store from '@/store';
import bus from '@/utils/bus';
type TState = {
    fatherId: number
    dataList: Array<TMaterialList>
    listLoading: boolean
    btnLoading: boolean
    inputValue: string
    activeIndex: number | string
    fileId: number
    commentPage: number
    commentPageSize: number
    commentTotal: number
    commentList: Array<TCommentDataType>
    isMore: boolean
    keyword: string
    filePage: number
    filePageSize: number
    fileTotal: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { onPreview, addExtension, downLoad, previewPic } = fileHandle()

const router = useRouter()
const route = useRoute()

const state = reactive<TState>({
    fatherId: 0,
    dataList: [],
    listLoading: false,
    btnLoading: false,
    inputValue: '',
    activeIndex: '',
    fileId: 0,
    commentPage: 1,
    commentPageSize: 5,
    commentTotal: 0,
    commentList: [],
    isMore: false,
    keyword: '',
    filePage: 1,
    filePageSize: 20,
    fileTotal: 0,
})



onMounted(async () => {
    if (route.query.keyword) {
        state.keyword = route.query.keyword as string
        state.filePage = 1
        getSearchResourcesData()
    }
})

bus.on('eventName', (data: string) => {
    state.keyword = data
    state.filePage = 1
    getSearchResourcesData()
})




//查看图片
const previewPicClick = (row: TMaterialList, index: number) => {
    if (row.DownState && row.Type === 4) {
        state.dataList[index].isPic = !state.dataList[index].isPic
    }
}
//下载图片
const dowmClick = (item: TMaterialList, index: number) => {
    if (!item.DownState) {
        return
    }
    downLoad(item)
}

//获取详情列表数据
const getSearchResourcesData = async () => {
    let data = {
        SearchKey: state.keyword,
        PageIndex: state.filePage,
        PageSize: state.filePageSize
    }
    state.listLoading = true
    try {
        const res = await getSearchResources(data)
        if (res.Code === 200) {
            let { Data, Total } = res?.Data
            state.dataList = Data
            state.fileTotal = Total
            state.dataList.map(item => item.isPic = false)
        } else {
            ElMessage.error(res.Message)
        }
    } catch (error) {

    } finally {
        state.listLoading = false
    }

}





//是否显示评论
const onTaggerComment = async (row: TMaterialList, index: number) => {
    state.commentList = []
    if (state.activeIndex === index) {
        state.activeIndex = ''
        state.commentPage = 1
        state.isMore = false
    } else {
        state.fileId = row.Id
        getCommentData()
        state.activeIndex = index
    }
}
//获取评论信息
const getCommentData = async () => {
    let data = {
        ObjId: state.fileId,
        Type: 3,
        PageIndex: state.commentPage,
        PageSize: state.commentPageSize
    }
    const res = await getCommentList(data)
    if (res.Code === 200) {
        let { Data, Total } = res?.Data
        state.commentList = state.commentList.concat(Data)
        state.commentTotal = Total
        state.isMore = Math.ceil(state.commentTotal / state.commentPageSize) === state.commentPage
    } else {
        ElMessage.error(res.Message)
    }
}
//提交评论
const onCommentSubmit = async () => {
    let data = {
        ObjId: state.fileId,
        Type: 3,
        Content: state.inputValue
    }
    state.btnLoading = true
    try {
        const res = await getAddComment(data)
        if (res.Code === 200) {
            state.inputValue = ''
            ElMessage.success('添加评论成功')
        } else {
            ElMessage.error(res.Message)
        }
    } catch (error) {

    } finally {
        state.btnLoading = false
    }
}


//收藏
const onCollection = async (row: TMaterialList, index: number) => {
    if (row.IsCollection) {
        //取消收藏
        const res = await getRemoveCollect({ ObjId: row.Id, ObjType: 3 })
        if (res.Code === 200) {
            state.dataList[index].IsCollection = !state.dataList[index].IsCollection
            ElMessage.success('取消收藏成功')
        } else {
            ElMessage.error(res.Message)
        }
    } else {
        //收藏
        const res = await getAddCollect({ ObjId: row.Id, ObjType: 3 })
        if (res.Code === 200) {
            state.dataList[index].IsCollection = !state.dataList[index].IsCollection
            ElMessage.success('收藏成功')
        } else {
            ElMessage.error(res.Message)
        }
    }
}
//点赞
const onFabulous = async (row: TMaterialList, index: number) => {
    if (row.IsFabulous) {
        //取消点赞
        const res = await getRemoveFabulous({ ObjId: row.Id, ObjType: 3 })
        if (res.Code === 200) {
            state.dataList[index].IsFabulous = !state.dataList[index].IsFabulous
            ElMessage.success('取消点赞成功')
        } else {
            ElMessage.error(res.Message)
        }
    } else {
        //点赞
        const res = await getAddFabulous({ ObjId: row.Id, ObjType: 3 })
        if (res.Code === 200) {
            state.dataList[index].IsFabulous = !state.dataList[index].IsFabulous
            ElMessage.success('点赞成功')
        } else {
            ElMessage.error(res.Message)
        }
    }
}
//返回上级页面
const onBack = () => {
    router.back()
}


//查看更多评论
const onLookMore = () => {
    state.commentPage++
    getCommentData()
}
//分页
const handleCurrentChange = (val: number) => {
    state.filePage = val
    getSearchResourcesData()
}



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "data_back" }, [
      _createElementVNode("div", {
        class: "back_left",
        onClick: onBack
      }, _hoisted_4),
      _hoisted_5
    ]),
    (state.dataList.length>0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.dataList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "cont_left",
                  onClick: ($event: any) => (_unref(onPreview)(item,index))
                }, [
                  (item.Type !== 4)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(getFileTypeImg)(item.Extension),
                        alt: ""
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: ($event: any) => (previewPicClick(item,index))
                      }, [
                        _createVNode(_component_el_image, {
                          style: {"width":"44px","height":"44px","margin-right":"10px"},
                          src: item.Url,
                          "preview-src-list": [item.Url],
                          "initial-index": 4,
                          fit: "cover",
                          ref_for: true,
                          ref_key: "previewPic",
                          ref: previewPic
                        }, null, 8, ["src", "preview-src-list"])
                      ], 8, _hoisted_10)),
                  _createElementVNode("span", {
                    class: _normalizeClass({Color:item.Type === 4})
                  }, _toDisplayString(_unref(addExtension)(item)), 3),
                  _createElementVNode("span", _hoisted_11, _toDisplayString((item.Size/1024).toFixed(2)) + "M", 1)
                ], 8, _hoisted_8),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "collect_item",
                    onClick: ($event: any) => (dowmClick(item,index))
                  }, [
                    (item.DownState)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                      : (_openBlock(), _createElementBlock("img", _hoisted_15)),
                    _hoisted_16
                  ], 8, _hoisted_13),
                  _createElementVNode("div", {
                    class: "collect_item",
                    onClick: ($event: any) => (onCollection(item,index))
                  }, [
                    (item.IsCollection)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                      : (_openBlock(), _createElementBlock("img", _hoisted_19)),
                    _hoisted_20
                  ], 8, _hoisted_17),
                  _createElementVNode("div", {
                    class: "collect_item",
                    onClick: ($event: any) => (onFabulous(item,index))
                  }, [
                    (item.IsFabulous)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                      : (_openBlock(), _createElementBlock("img", _hoisted_23)),
                    _hoisted_24
                  ], 8, _hoisted_21),
                  _createElementVNode("div", {
                    class: "collect_item",
                    onClick: ($event: any) => (onTaggerComment(item,index))
                  }, _hoisted_28, 8, _hoisted_25)
                ])
              ]),
              (state.activeIndex === index)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_el_input, {
                        modelValue: state.inputValue,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.inputValue) = $event)),
                        placeholder: "发布你的评论",
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_button, {
                        loading: state.btnLoading,
                        onClick: onCommentSubmit
                      }, {
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    (state.commentList.length>0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.commentList, (commentItem, commentIndex) => {
                              return (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(commentItem.UserName) + "：", 1),
                                  _createElementVNode("span", _hoisted_38, _toDisplayString(commentItem.Content), 1),
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(commentItem.CreateTime), 1)
                                ])
                              ]))
                            }), 256))
                          ]),
                          (!state.isMore)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "comm_item_btn",
                                onClick: onLookMore
                              }, " 查看更多评论 "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_40, "没有更多数据了"))
                        ]))
                      : (_openBlock(), _createBlock(_component_el_empty, {
                          key: 1,
                          description: "暂无评论"
                        }))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_el_pagination, {
              "page-size": state.filePageSize,
              "pager-count": 10,
              layout: "prev, pager, next",
              total: state.fileTotal,
              onCurrentChange: handleCurrentChange
            }, null, 8, ["page-size", "total"]),
            _createElementVNode("div", _hoisted_42, "总共 " + _toDisplayString(state.fileTotal) + " 条", 1)
          ])
        ])), [
          [_directive_loading, state.listLoading]
        ])
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "暂无数据"
        }))
  ]))
}
}

})